var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.364 2.34a.75.75 0 0 1 1.06 0l2.611 2.61 2.54-2.539a.75.75 0 0 1 1.06 1.06l-2.54 2.54 2.522 2.521a.75.75 0 0 1-1.06 1.06l-2.522-2.52L3.447 9.66a.75.75 0 0 1-1.06-1.06l2.588-2.59-2.61-2.61a.75.75 0 0 1 0-1.06Z",
    fill: "#151414"
  })));
};
export default SvgClose;